// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
 export const firebaseConfig = {
  apiKey: "AIzaSyA3pT5azgU-s5D_8Aa_EUa_6hpohTKbxTQ",
  authDomain: "e-learning-app-8cef4.firebaseapp.com",
  projectId: "e-learning-app-8cef4",
  storageBucket: "e-learning-app-8cef4.firebasestorage.app",
  messagingSenderId: "463231649871",
  appId: "1:463231649871:web:d2c1a732584d77ad69c23a",
  measurementId: "G-TRHPX5Y216"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "europe-west3");